import CardActionArea from '@material-ui/core/CardActionArea';
import React from 'react';

export const SwitchableCardActionArea: React.FC<{
  noAction?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}> = ({ children, noAction = false, onClick }) => {
  return <>{noAction ? children : <CardActionArea onClick={onClick}>{children}</CardActionArea>}</>;
};
